export const copyToClipboard = async (text) => {
    if (!text) return false;
  
    if (navigator.clipboard) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  
    const textarea = document.createElement('textarea');
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    const success = document.execCommand('copy');
    document.body.removeChild(textarea);
    return success;
  };
  